import React from "react";
import { Download, ArrowUpRight } from "lucide-react";

// Home Section Component
function HomeSection({ setCurrentPage }) {
  return (
    <section id="home" className="t-hero">
      {/* Left: role + intro */}
      <div>
        <h1 className="t-display t-hero__big">
          Software
          <br />
          Developer
        </h1>
        <p className="t-eyebrow" style={{ marginTop: 28 }}>
          Hi, I&apos;m <span className="t-text-yellow">Taelo Seholoba</span>
        </p>
        <p className="t-hero__intro">
          A passionate software developer building engaging, high-performance
          web applications with React, TypeScript and .NET.
        </p>
        <div className="t-hero__actions">
          <button className="t-btn" onClick={() => setCurrentPage("projects")}>
            View my projects <ArrowUpRight size={16} />
          </button>
          <a
            className="t-btn t-btn--ghost"
            href="https://drive.google.com/file/d/1oapjwjdfBUOrLnCLfa-gItP_HLCOt0km/view?usp=drive_link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Download size={16} /> Resume
          </a>
        </div>
      </div>

      {/* Centre: photo */}
      <div className="t-hero__photo">
        <img
          src="/assets/img/me.jpg"
          alt="Taelo Seholoba"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "https://placehold.co/260x340/3553b8/ffffff?text=TS";
          }}
        />
      </div>

      {/* Right: tagline */}
      <div className="t-hero__right">
        <h2 className="t-display t-hero__big">
          Full
          <br />
          Stack
          <br />
          <span className="t-text-yellow">Coder</span>
        </h2>
      </div>
    </section>
  );
}

export default HomeSection;
